import { ToolTypes } from '@labradorsports/constants';

import { distanceFromLine, findClosestPointOnLine } from '../utils/index.js';

import { PluginContext } from './api.js';

function findPerpendicularSnapLines(lines: AnchorLine[], anchor: Anchor, offset: ScreenPoint): AnchorLine[] {
    const horizontalLines = lines.filter((line) => line.angle === 0 && line.piece.id !== anchor.id);
    const verticalLines = lines.filter((line) => line.angle === 90 && line.piece.id !== anchor.id);

    const horizontalLinesByDistance = horizontalLines.sort((line1, line2) => {
        return distanceFromLine(offset, line1) - distanceFromLine(offset, line2);
    });

    const verticalLinesByDistance = verticalLines.sort((line1, line2) => {
        return distanceFromLine(offset, line1) - distanceFromLine(offset, line2);
    });

    return [horizontalLinesByDistance[0], verticalLinesByDistance[0]].filter(
        (line) => Boolean(line) && distanceFromLine(offset, line) < 10
    );
}

export default {
    types: [ToolTypes.BLUEPLAYER, ToolTypes.ORANGEPLAYER, ToolTypes.COACH],

    generateLines({ frame }) {
        return frame.players.flatMap((player) => {
            return [
                {
                    a: {
                        x: 0,
                        y: player.origin.y,
                    },
                    b: {
                        x: frame.field.width,
                        y: player.origin.y,
                    },
                    piece: player,
                },
                {
                    a: {
                        x: player.origin.x,
                        y: 0,
                    },
                    b: {
                        x: player.origin.x,
                        y: frame.field.height,
                    },
                    piece: player,
                },
            ];
        });
    },

    handleDragEnd: ({ api, frame, fieldViewport, lines }, anchor, offset) => {
        if (anchor.pointerType === 'keyboard' || typeof anchor.id !== 'number') {
            return;
        }

        const pixelOffset = fieldViewport.getPixelCoords(offset);
        const snapTo = findPerpendicularSnapLines(lines, anchor, pixelOffset);

        const snappedPoints = snapTo.map((line) => findClosestPointOnLine(pixelOffset, line));

        if (snappedPoints.length > 0) {
            const snapPoint =
                snappedPoints.length === 1
                    ? snappedPoints[0]
                    : {
                          y: snappedPoints[0].y,
                          x: snappedPoints[1].x,
                      };

            api.updatePlayer(anchor.id, {
                type: anchor.type,
                origin: frame.field.clampCoords(fieldViewport.getFieldCoords(snapPoint)),
            });
        }
    },

    handleDrag: ({ lines, fieldViewport, frame, api }, anchor, offset) => {
        if (anchor.pointerType === 'keyboard' || typeof anchor.id !== 'number') {
            return;
        }

        const pixelOffset = fieldViewport.getPixelCoords(offset);
        const snapTo = findPerpendicularSnapLines(lines, anchor, pixelOffset);

        const snappedPoints = snapTo.map((line) => findClosestPointOnLine(pixelOffset, line));

        if (snappedPoints.length > 0) {
            const snapPoint =
                snappedPoints.length === 1
                    ? snappedPoints[0]
                    : {
                          y: snappedPoints[0].y,
                          x: snappedPoints[1].x,
                      };
            frame.updatePlayer(anchor.target, fieldViewport.getFieldCoords(snapPoint));

            api.showOverlayItems(snapTo.map((line) => fieldViewport.getFieldLine(line)));
        } else {
            api.showOverlayItems([]);
        }
    },
} as PlayPlugin<PluginContext>;
